
import * as handlebars_family from "../handlebars_family.js";
import "../mealplanner/recipeCategories.mustache";
import "../widget/action-menu.js";
const TPL = handlebars_family.addTemplate("mealplanner/recipePreview",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }, buffer = 
  "background-image:url('";
  stack1 = ((helper = (helper = lookupProperty(helpers,"medias") || (depth0 != null ? lookupProperty(depth0,"medias") : depth0)) != null ? helper : container.hooks.helperMissing),(options={"name":"medias","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":194},"end":{"line":1,"column":256}}}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!lookupProperty(helpers,"medias")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + "');";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(data && lookupProperty(data,"first")),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":205},"end":{"line":1,"column":245}}})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression((lookupProperty(helpers,"url")||(depth0 && lookupProperty(depth0,"url"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),512,512,"r",{"name":"url","hash":{},"data":data,"loc":{"start":{"line":1,"column":219},"end":{"line":1,"column":238}}}));
},"5":function(container,depth0,helpers,partials,data) {
    return "background-image:url('images/meaplanner_recipe_quick_view_default_cover@2x.png');";
},"7":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<icon class=\"color-branded\" titleHTML=\""
    + container.escapeExpression(lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"mp.seerecipe",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":792},"end":{"line":1,"column":815}}}))
    + "\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"recipe.ic_toque",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":817},"end":{"line":1,"column":846}}}))
    + "</icon>";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <p><span class=\"mp-recipepreview-field-name\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"mp.preptime",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":934},"end":{"line":1,"column":958}}})) != null ? stack1 : "")
    + " :</span> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"prepHour") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":968},"end":{"line":1,"column":1006}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"prepMin") : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1007},"end":{"line":1,"column":1047}}})) != null ? stack1 : "")
    + "</p> ";
},"10":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"prepHour") : depth0), depth0))
    + "h";
},"12":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"prepMin") : depth0), depth0))
    + " mins";
},"14":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <p><span class=\"mp-recipepreview-field-name\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"mp.cooktime",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":1122},"end":{"line":1,"column":1146}}})) != null ? stack1 : "")
    + " :</span> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cookHour") : depth0),{"name":"if","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1156},"end":{"line":1,"column":1194}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cookMin") : depth0),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1195},"end":{"line":1,"column":1235}}})) != null ? stack1 : "")
    + "</td> ";
},"15":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"cookHour") : depth0), depth0))
    + "h";
},"17":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"cookMin") : depth0), depth0))
    + " mins";
},"19":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <p><span class=\"mp-recipepreview-field-name\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"labels.servings",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":1309},"end":{"line":1,"column":1337}}})) != null ? stack1 : "")
    + " :</span> "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"serves") : depth0), depth0))
    + "</p> ";
},"21":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <p class=\"recipe-field-name fw-text-ellipsis\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"mp.viewonurl",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":1430},"end":{"line":1,"column":1455}}})) != null ? stack1 : "")
    + " <a target=\"_new\" href=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"url") : depth0), depth0))
    + "\" class=\"color-branded\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"host") : depth0), depth0))
    + "</a></p> ";
},"23":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <ul style=\"padding-left:20px;\"> "
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ingredientsList") : depth0),{"name":"each","hash":{},"fn":container.program(24, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1765},"end":{"line":1,"column":1869}}})) != null ? stack1 : "")
    + " </ul> ";
},"24":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<li>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"complementData") : depth0),{"name":"if","hash":{},"fn":container.program(25, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1804},"end":{"line":1,"column":1855}}})) != null ? stack1 : "")
    + "</li>";
},"25":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ", "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"complementData") : depth0), depth0));
},"27":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <p class=\"mp-recipepreview-empty\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"mp.ingredientsvoid",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":1919},"end":{"line":1,"column":1950}}})) != null ? stack1 : "")
    + "</p> ";
},"29":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div data-fw-onclick=\"mprecipeedit|ingredients\" class=\"color-branded rb-button\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"mp.ingredientsadd",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":2068},"end":{"line":1,"column":2098}}})) != null ? stack1 : "")
    + "</div> ";
},"31":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <p style=\"white-space: pre-wrap;\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"instructions") : depth0), depth0))
    + "</p> ";
},"33":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <p class=\"mp-recipepreview-empty\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"mp.instructionsvoid",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":2318},"end":{"line":1,"column":2350}}})) != null ? stack1 : "")
    + "</p> ";
},"35":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div data-fw-onclick=\"mprecipeedit|instructions\" class=\"color-branded rb-button\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"mp.instructionsadd",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":2469},"end":{"line":1,"column":2500}}})) != null ? stack1 : "")
    + "</div> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"mp-recipe\" style=\"box-sizing:border-box;\" data-fw-meta-id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\" draggable=\"true\"><div class=\"mp-recipepreview-cover\" style=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"medias") : depth0)) != null ? lookupProperty(stack1,"0") : stack1)) != null ? lookupProperty(stack1,"pictureUrl") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(5, data, 0),"data":data,"loc":{"start":{"line":1,"column":145},"end":{"line":1,"column":355}}})) != null ? stack1 : "")
    + "\"><icon class=\"close\" data-fw-onclick=\"mppreviewclose\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_close",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":410},"end":{"line":1,"column":432}}}))
    + "</icon><icon data-widget=\"widget/action-menu\" data-key=\"mprecipemenu\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_more_vertical",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":502},"end":{"line":1,"column":532}}}))
    + "</icon></div><div class=\"fw-padding-responsive\" style=\"border-bottom:var(--border);line-height:200%\"><flexrow class=\"mp-recipepreview-name\" data-fw-onclick=\"mprecipeview\"><flexauto> "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + " </flexauto> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isRecipe") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":737},"end":{"line":1,"column":860}}})) != null ? stack1 : "")
    + " </flexrow> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"prepTime") : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":872},"end":{"line":1,"column":1059}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cookTime") : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1060},"end":{"line":1,"column":1248}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"serves") : depth0),{"name":"if","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1249},"end":{"line":1,"column":1371}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"url") : depth0),{"name":"if","hash":{},"fn":container.program(21, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1372},"end":{"line":1,"column":1538}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = container.invokePartial(lookupProperty(partials,"mealplanner/recipeCategories"),depth0,{"name":"mealplanner/recipeCategories","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " </div><div class=\"fw-padding-responsive\" style=\"border-bottom:var(--border);line-height:200%\"><p><b>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"mp.ingredients",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":1673},"end":{"line":1,"column":1700}}})) != null ? stack1 : "")
    + "</b></p> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ingredientsList") : depth0),{"name":"if","hash":{},"fn":container.program(23, data, 0),"inverse":container.program(27, data, 0),"data":data,"loc":{"start":{"line":1,"column":1709},"end":{"line":1,"column":1962}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"rights") : depth0)) != null ? lookupProperty(stack1,"canUpdate") : stack1),{"name":"if","hash":{},"fn":container.program(29, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1963},"end":{"line":1,"column":2112}}})) != null ? stack1 : "")
    + " </div><div class=\"fw-padding-responsive\"><p><b>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"mp.instructions",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":2160},"end":{"line":1,"column":2188}}})) != null ? stack1 : "")
    + "</b></p> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"instructions") : depth0),{"name":"if","hash":{},"fn":container.program(31, data, 0),"inverse":container.program(33, data, 0),"data":data,"loc":{"start":{"line":1,"column":2197},"end":{"line":1,"column":2362}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"rights") : depth0)) != null ? lookupProperty(stack1,"canUpdate") : stack1),{"name":"if","hash":{},"fn":container.program(35, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":2363},"end":{"line":1,"column":2514}}})) != null ? stack1 : "")
    + " </div></div> ";
},"usePartial":true,"useData":true});
export default TPL;